import { render, staticRenderFns } from "./EditSkills.vue?vue&type=template&id=08ec085e&"
import script from "./EditSkills.vue?vue&type=script&lang=js&"
export * from "./EditSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports